import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { CommonModule } from '@angular/common';
import { HttpResponse } from '@angular/common/http';
import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatChipInputEvent } from '@angular/material/chips';
import { MatIconModule } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { Router, RouterModule } from '@angular/router';
import {
    ApiRequestService,
    FileData,
    FileexplorerComponent,
    FilemanagerService,
    TinyMCEHtmlEditorComponent,
    TranslationPipe
} from '@prekog/common-ui';
import { NewsletterTemplate } from '../model/newsletter-template.model';
import { AddNewsletterRequest } from './addnewsletterrequest';

@Component({
    selector: 'app-add-newsletter',
    templateUrl: './add-newsletter.component.html',
    styleUrls: ['./add-newsletter.component.scss'],
    standalone: true,
    imports: [
        MatIconModule,
        FormsModule,
        RouterModule,
        TranslationPipe,
        TinyMCEHtmlEditorComponent,
        FileexplorerComponent,
        CommonModule,
        FormsModule,
        ReactiveFormsModule
    ]
})
export class AddNewsletterComponent {
    addNewsletterURL = '/admin/addNewsletter';
    emailBaseUrl: string;
    fileDataList: FileData[] = [];
    htmlForm?: FormGroup;

    newsLetterForm?: FormGroup;

    newsletterTemplate?: NewsletterTemplate;

    readonly separatorKeysCodes = [ENTER, COMMA] as const;

    constructor(
        private _router: Router,
        @Inject('EMAIL_BACKEND_URL') private _emailBaseUrl: string,
        private _fb: FormBuilder,
        private _apiRequestService: ApiRequestService,
        private sanitizer: DomSanitizer,
        private _fileManagerService: FilemanagerService
    ) {
        this.emailBaseUrl = _emailBaseUrl;
        this.createHtmlForm();
        this.createNewsLetterForm();
    }

    addEmailTemplate() {
        this.collectNewsletter();

        const addNewsletterRequest: AddNewsletterRequest = {
            newsletterTemplate: this.newsletterTemplate,
            fileDataList: this.fileDataList
        };

        this._apiRequestService
            .sendRequest<
                AddNewsletterRequest,
                HttpResponse<any>
            >(this.emailBaseUrl, addNewsletterRequest, true, this.addNewsletterURL, true)
            .subscribe(() => {
                this._router.navigateByUrl('/email');
            });
    }

    createHtmlForm() {
        this.htmlForm = this._fb.group({
            html: ['', [Validators.required]]
        });
    }

    createNewsLetterForm() {
        this.newsLetterForm = this._fb.group({
            subject: ['', [Validators.required]],
            templateName: ['', [Validators.required]]
        });
    }

    collectNewsletter() {
        this.newsletterTemplate = {
            templateName: this.newsLetterForm?.controls['templateName'].value as string | undefined,
            subject: this.newsLetterForm?.controls['subject'].value as string | undefined,
            message: this.htmlForm?.controls['html'].value as string | undefined
        };
    }

    addAttachment(event: MatChipInputEvent): void {
        const input = event.chipInput?.inputElement;
        const value = (event.value || '').trim();

        if (value) {
            const isDuplicate = this.fileDataList.some((file) => file.url === value);

            if (!isDuplicate) {
                const fileNameFromUrl = value.split('/').pop() || 'Új fájl';

                this.fileDataList.push({
                    url: value,
                    fileName: fileNameFromUrl
                });
            }
        }
        if (input) {
            input.value = '';
        }
    }

    removeAttachment(fileData: FileData): void {
        const index = this.fileDataList.indexOf(fileData);

        if (index >= 0) {
            this.fileDataList.splice(index, 1);
        }
    }

    getSafeUrl(url: string) {
        return this.sanitizer.bypassSecurityTrustUrl(url);
    }

    openFile(url: string): void {
        if (url) {
            window.open(url, '_blank');
        }
    }

    isImage(fileName: string | undefined): boolean {
        return this._fileManagerService.isImage(fileName);
    }
}
